import { z } from 'zod'

// state комнатной записи и дорожек: recording | ready | failed. Держим строкой —
// вьюер устойчив к незнакомым состояниям, известные разбирает по месту.
export const RecordingTrackSchema = z.object({
  participantId: z.string(),
  identity: z.string(),
  state: z.string(),
  url: z.string().optional(),
  startedAt: z.string().optional(),
  endedAt: z.string().optional(),
})
export type RecordingTrack = z.infer<typeof RecordingTrackSchema>

export const RecordingCompositeSchema = z.object({
  state: z.string(),
  url: z.string().optional(),
  startedAt: z.string().optional(),
  endedAt: z.string().optional(),
})
export type RecordingComposite = z.infer<typeof RecordingCompositeSchema>

export const RecordingSchema = z.object({
  meetingId: z.string(),
  state: z.string(),
  tracks: z.array(RecordingTrackSchema),
  composite: RecordingCompositeSchema.optional(),
})
export type Recording = z.infer<typeof RecordingSchema>
